import React from 'react';
import { storyblokEditable } from '@storyblok/react';
import { AddressSelectionData } from '../../../types';
import { BannerWrapper, Banner, BannerTitle, BannerContent } from './FreeDeliveryBanner';
import { useStory } from '../../../../storyblok/hooks/useStoryblok';

export const PreorderBanner: React.FC = () => {
  const { data } = useStory<AddressSelectionData>('address-selection', 'addressSelection');

  if (!data) return null;

  const { preorder_title: title, preorder_description: description } = data;

  if (!title || !description) return null;

  return (
    <BannerWrapper>
      <Banner>
        <BannerTitle>
          <h4>{title}</h4>
        </BannerTitle>
        <BannerContent {...storyblokEditable(data)}>{description}</BannerContent>
      </Banner>
    </BannerWrapper>
  );
};
